import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const StoryGroupService = {
  async getStoryGroups(page, perPage) {
    const params = generateQueryParams({ page, size: perPage });

    const res = await axios.get('org/v1/story-groups/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getAllStoryGroups() {
    const res = await axios.get('org/v1/story-groups/select/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createStoryGroup(payload) {
    const res = await axios.post('org/v1/story-groups/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteStoryGroup(id) {
    const res = await axios.delete(`org/v1/story-groups/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateStoryGroup(payload, id) {
    const res = await axios.put(`org/v1/story-groups/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
